import React from "react";
import { useDispatch } from "react-redux";
import { getLocalizedString } from "@icarius-localization/strings";
import { CloseIcon } from "@icarius-icons";
import {
  Grid,
  DialogContent,
  DialogActions,
  DialogTitle,
  Dialog,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import DialogTransition from "@icarius-common/dialogTransition";
import PaperDraggable from "@icarius-common/paperDraggable";
import useHandleFormDuplicate from "./useHandleFormDuplicate";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";

const gridStyle = { height: 75, padding: "10px" };

const DuplicateDialog = (props) => {

  const { data, open, entryList, conceptList, imputationList, handleConfirm, handleClose } = props;

  const dispatch = useDispatch();

  const openValidationError = () => {
    dispatch(openSnackbarAction({ msg: getLocalizedString("invalidData"), severity: "error", duration: 10000 }));
  }

  const {
    formData,
    setFormValue,
    submit
  } = useHandleFormDuplicate(data, handleConfirm, openValidationError);

  return (
    <Dialog
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      open={open}
      scroll={"paper"}
      fullWidth
      maxWidth={"sm"}>
      <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
        {getLocalizedString("duplicate")}
        <DialogTitleDivider />
      </DialogTitle>
      <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
      <DialogContent style={{ paddingTop: 0 }}>
        <Grid container item xs={12}>
          <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}> {/* entry */}
            <FormControl style={{ width: "100%" }}>
              <InputLabel required id={`label-entry`}>{getLocalizedString("accountingEntry")}</InputLabel>
              <Select
                value={formData.entry}
                labelId={`label-entry`}
                id={`select-entry`}
                onChange={(e) => setFormValue(e.target.value, "entry")}
                margin={"none"}
              >
                {
                  entryList.map(item => (
                    <MenuItem
                      className={"whiteText"}
                      key={item.key}
                      value={item.key}>
                      {item.value}
                    </MenuItem>
                  ))
                }
              </Select>
            </FormControl>
          </Grid>
          <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}> {/* concept */}
            <FormControl style={{ width: "100%" }}>
              <InputLabel required id={`label-concept`}>{getLocalizedString("concept")}</InputLabel>
              <Select
                value={formData.concept}
                labelId={`label-concept`}
                id={`select-concept`}
                onChange={(e) => setFormValue(e.target.value, "concept")}
                margin={"none"}
              >
                {
                  conceptList.map(item => (
                    <MenuItem
                      className={"whiteText"}
                      key={item.key}
                      value={item.key}>
                      {item.value}
                    </MenuItem>
                  ))
                }
              </Select>
            </FormControl>
          </Grid>
          <Grid container item alignItems="center" xs={12} md={6} style={gridStyle}> {/* condition */}
            <TextField
              fullWidth
              margin={"none"}
              label={getLocalizedString("condition")}
              value={formData.condition}
              onChange={(e) => setFormValue(e.target.value, "condition")}
            />
          </Grid>
          <Grid container item alignItems="center" xs={12} md={6} style={gridStyle}> {/* account */}
            <TextField
              required
              fullWidth
              margin={"none"}
              label={getLocalizedString("accountCode")}
              value={formData.account}
              onChange={(e) => setFormValue(e.target.value, "account")}
            />
          </Grid>
          <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}> {/* imputation */}
            <FormControl style={{ width: "100%" }}>
              <InputLabel required id={`label-imputation`}>{getLocalizedString("imputation")}</InputLabel>
              <Select
                value={formData.imputation}
                labelId={`label-imputation`}
                id={`select-imputation`}
                onChange={(e) => setFormValue(e.target.value, "imputation")}
                margin={"none"}
              >
                {
                  imputationList.map(item => (
                    <MenuItem
                      className={"whiteText"}
                      key={item.key}
                      value={item.key}>
                      {item.value}
                    </MenuItem>
                  ))
                }
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <ButtonDialogAction onClick={handleClose} text={getLocalizedString("cancel")} />
        <ButtonDialogAction onClick={submit} isAccept text={getLocalizedString("accept")} />
      </DialogActions>
    </Dialog>
  );
}

export default DuplicateDialog;
